import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ActionButton } from './ActionButton';
import { Menu } from 'primereact/menu';
import $ from 'jquery';
import {saveAs} from 'file-saver';
import {t} from 'i18next';
import InvoiceService from '../services/InvoiceService';
import AuthService from '../services/AuthService';

export class InvoiceAttachmentDownloadComponent extends Component {
    constructor(props) {
        super(props);
        this.service = new InvoiceService();
        this.authService = new AuthService();
        this.user = this.authService.getProfile();
        const items = [];
        if (props.pdf === true) {
            items.push({
                label: 'PDF',
                icon: 'pi',
                command: e => this.downloadFile('pdf', e, this.props.rowData),
            });
        }
        if (props.xlsx === true) {
            items.push({
                label: 'XLSX',
                icon: 'pi',
                command: e => this.downloadFile('xlsx', e, this.props.rowData),
            });
        }
        if (props.xls === true) {
            items.push({
                label: 'XLS',
                icon: 'pi',
                command: (a,b,c,d,e) => this.downloadFile('xls', e, this.props.rowData),
            });
        }
        if (props.csv) {
            items.push({
                label: 'CSV',
                icon: 'pi',
                command: e => this.downloadFile('csv', e, this.props.rowData),
            });
        }
        if (props.ods) {
            items.push({
                label: 'ODS',
                icon: 'pi',
                command: e => this.downloadFile('ods', e, this.props.rowData),
            });
        }
        this.state = {
            items,
        };
        this.menuRef = React.createRef();
        this.downloadFile = this.downloadFile.bind(this);
    }

    componentDidMount() {
        // eslint-disable-next-line no-undef
        $('a.p-menuitem-link').removeAttr('href');
    }

    componentDidUpdate() {
        // eslint-disable-next-line no-undef
        // if ($ !== undefined) {
        // 	$('a.p-menuitem-link').removeAttr('href');
        // }
    }

    onButtonClick(event) {
        if (event) {
            event.preventDefault();
        }
        this.menuRef.current.toggle(event);
    }

    downloadFile(format, event,rowData) {
        if (event) {
            event.originalEvent.preventDefault();
        }
        if (!!rowData) {
            this.service
                .downloadInvoiceAttachment(rowData.petraFileId, rowData.invoiceNumber, rowData.invoiceDate, format)
                .then((response) => {
                    if(response.size === 0 && response.type === ""){
                        this.props.messageFcn('INFO', t('invoice.downloadAttachmentInfo'))
                    } else {
                        const fileName = t('invoice.downloadAttachmentFileName') + ` ${rowData.invoiceNumber}.${format}`
                        saveAs(response, fileName);
                    }
                    
                })
                .catch((err) => {
                    this.props.messageFcn('ERROR', t('invoice.downloadAttachmentError'))

                });
        } 
    }

    render() {
        const { items } = this.state;
        return (
            <React.Fragment>
                <Menu model={items} popup ref={this.menuRef} appendTo={document.body} />
                {this.props.invoiceList === true ?
                    <ActionButton
                        label={""}
                        iconSvg={this.props.iconSvg}
                        variant={this.props.variant}
                        handleClick={this.onButtonClick.bind(this)}
                        key={'download-invoice-button-att'}
                        disabled={this.user?.agreementSapRole === 'FLOTA' && !this.authService.isUserHasPermission('PERMISSION_EDIT_INVOICES')}
                    /> :
                    <ActionButton
                        label={this.props.label ? this.props.label : "ss"}
                        iconName="mdi-download"
                        iconSide="left"
                        iconColor="white"
                        downloadFile
                        handleClick={this.onButtonClick.bind(this)}
                        disabled={this.user?.agreementSapRole === 'FLOTA' && !this.authService.isUserHasPermission('PERMISSION_EDIT_INVOICES')}
                        rendered
                    />

                }


            </React.Fragment>
        );
    }
}

InvoiceAttachmentDownloadComponent.defaultProps = {
    csv: true,
    pdf: true,
    xlsx: true,
    xls: false,
    ods: true,
    reportFileNameBase: 'raport',
    iconSvg: "ico_invoice_doc",
    variant: 'invoice-download-pdf',
    invoiceList: false

};

InvoiceAttachmentDownloadComponent.propTypes = {
    csv: PropTypes.bool,
    ods: PropTypes.bool,
    className: PropTypes.string,
    generateReport: PropTypes.func.isRequired,
    label: PropTypes.string,
    pdf: PropTypes.bool,
    reportFileNameBase: PropTypes.string,
    xlsx: PropTypes.bool,
    iconSvg: PropTypes.string,
    variant: PropTypes.string,
    invoiceList: PropTypes.bool,
    rowData:PropTypes.object,
    messageFcn: PropTypes.func,
};